import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FullModeService } from 'src/app/services/full-mode.service';

declare var jQuery:any;
@Component({
  selector: 'app-revolution-slider-cluster',
  templateUrl: './revolution-slider-cluster.component.html',
  styleUrls: ['./revolution-slider-cluster.component.scss']
})
export class RevolutionSliderClusterComponent implements OnInit {
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute,
    public router:Router,
    public fullModeService: FullModeService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    jQuery(document).ready(function() {
      jQuery('#rev_slider_5_1').show().revolution({
        jsFileLocation: "js/",
        sliderLayout: "fullwidth",
        visibilityLevels: "1240,1024,778,480",
        gridwidth: "1440,1024,778,480",
        gridheight: "870,768,650,600",
        spinner: "spinner0",
        editorheight: "870,768,650,600",
        responsiveLevels: "1240,1024,778,480",
        disableProgressBar: "on",
        navigation: {
            onHoverStop: false
        },
        parallax: {
          levels: [5, 10, 15, 20, 25, 30, 35, 40, 45, 46, 47, 48, 49, 50, 51, 30],
          type: "mouse",
          origo: "slidercenter",
          speed: 0
        },
        fallbacks: {
          allowHTML5AutoPlayOnAndroid: true
        },
      });
    })
  }

  redirectToDownload(){
    if(this.fullModeService.fullMode==false){
      window.open('https://creator.se2.tech/#/?fullMode=false', '_blank');
    }else{
      window.open('https://creator.se2.tech/#/', '_blank');
    }
  }
}
